export default (state) => {
  if (!state.auth || !state.auth.currentUser) {
    return undefined;
  }

  const { customerNumber } = state.auth.currentUser;

  return customerNumber;
};
